import { render, staticRenderFns } from "./InstallmentsPlan.vue?vue&type=template&id=0785c9c3&"
import script from "./InstallmentsPlan.vue?vue&type=script&lang=js&"
export * from "./InstallmentsPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports